import { configureStore, combineReducers, Reducer, AnyAction, createAction } from '@reduxjs/toolkit';
import shellReducer from './reducers/shell';
import authorizationReducer from './reducers/authorization';
import interactionsReducer from './reducers/interactions';

// Action to reset the store
const resetType = 'RESET_STORE';
const resetAction = createAction(resetType);

type RootState = {
    shell: ReturnType<typeof shellReducer>;
    authorization: ReturnType<typeof authorizationReducer.reducer>;
    interactions: ReturnType<typeof interactionsReducer.reducer>;
};

// Create the root reducer by combining static and dynamic reducers
const createRootReducer = (): Reducer<RootState, AnyAction> => {
    const combinedReducer = combineReducers({
        shell: shellReducer,
        authorization: authorizationReducer.reducer,
        interactions: interactionsReducer.reducer
    });

    return (state, action) => {
        if (action.type === resetType) {
            state = undefined; // Force the store to reset
        }
        return combinedReducer(state, action);
    };
};

// Create the store with the initial reducer
const store = configureStore({
    reducer: createRootReducer()
});

export { store as default, resetAction, RootState };
